/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TenantPublicGradingSettingsGradeProjectorAnyOf } from './tenantPublicGradingSettingsGradeProjectorAnyOf';

export type TenantPublicGradingSettingsGradeProjector = TenantPublicGradingSettingsGradeProjectorAnyOf | null;
